import { render, staticRenderFns } from "./ChooseItRightForm.vue?vue&type=template&id=5a19bf02&scoped=true&lang=pug&"
import script from "./ChooseItRightForm.vue?vue&type=script&lang=js&"
export * from "./ChooseItRightForm.vue?vue&type=script&lang=js&"
import style0 from "./ChooseItRightForm.vue?vue&type=style&index=0&id=5a19bf02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a19bf02",
  null
  
)

export default component.exports